import React, { ReactElement } from "react";
import styles from "./Backdrop.module.css";

interface BackdropProps {
  close: () => void;
}

const Backdrop: React.FC<BackdropProps> = ({ close }): ReactElement => {
  return <div className={styles.backdrop} onClick={close} />;
};

export default Backdrop;
